import { Injectable } from '@angular/core';
import { Plan } from '@modules/super-admin/company/domain';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { Observable } from 'rxjs';
@Injectable()
export abstract class MembershipServices {
  /**
   * All Membership
   */
  abstract getAllMembership(query: ApiQueryParams): Observable<Plan[]>;

  /**
   * All Cards
   */
  abstract getAllCards(userId: string): Observable<any>;

  /**
   * Delete Card
   * @param cardId is the ID of the card to delete
   */
  abstract deleteCard(userId: string, paymentMethodId: string): Observable<any>;

  /**
   * Pay membership
   * @param membershipId the ID of the membership to pay
   */
  abstract subscribeToPlan(subscriptionData: {
    _planId: string;
    _userId: string;
    _cardId?: string;
  }): Observable<any>;
  /**
   * Pay membership
   */

  abstract updatePlanSubscription(
    companyId: string,
    data: {
      _planId: string;
      _userId: string;
      paymentMethodId?: string;
    }
  ): Observable<any>;
  /**
   * Pay membership
   * @param membershipId the ID of the membership to pay
   */
  abstract cancelMembership(
    _user: string,
    _subscription: string
  ): Observable<any>;

  /**
   * Add Card
   * @param card the card information to create
   */
  abstract addCard(userId: string, tokenId: any): Observable<any>;
}
